import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';

function Accordion(props) {
  var header = props.header,
    content = props.content,
    open = props.open,
    className = props.className,
    disabled = props.disabled,
    card = props.card;
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    accordionOpen = _useState2[0],
    setAccordionOpen = _useState2[1];
  var _useState3 = useState(open),
    _useState4 = _slicedToArray(_useState3, 2),
    defaultOpenState = _useState4[0],
    setDefaultOpenState = _useState4[1];
  useEffect(function () {
    if (!disabled && open !== defaultOpenState) {
      setAccordionOpen(open);
      setDefaultOpenState(open);
    }
  }, [open, disabled, accordionOpen, defaultOpenState]);
  function handleAccordionHeaderClick() {
    if (!disabled) {
      setAccordionOpen(!accordionOpen);
    }
  }
  var accordionClasses = "bf-accordion-main-wrapper\n        ".concat(accordionOpen ? 'bf-accordion-open' : 'bf-accordion-closed', "\n        ").concat(disabled ? 'bf-accordion-disabled bf-accordion-closed' : '', "\n        ").concat(card ? 'bf-accordion-card' : '', "\n        ").concat(className, "\n    ");
  return /*#__PURE__*/React__default.createElement("div", {
    className: accordionClasses
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-accordion-header-wrapper",
    onClick: handleAccordionHeaderClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-accordion-header-title"
  }, header), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-accordion-header-caret-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-accordion-header-caret"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-accordion-content-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-accordion-content"
  }, content)));
}
Accordion.defaultProps = {
  header: '',
  content: '',
  open: false,
  className: '',
  disabled: false,
  card: true
};
Accordion.propTypes = {
  /**
  Accordion header content
   */
  header: nodeOrStringProp,
  /**
  Accordion content
   */
  content: nodeOrStringProp,
  /**
  Set open state
   */
  open: PropTypes.bool,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Set disabled state
   */
  disabled: PropTypes.bool,
  /**
  Show as a card
   */
  card: PropTypes.bool
};

export { Accordion as A };
//# sourceMappingURL=Accordion-ba12c90d.js.map
